<template>
	<v-layout justify-space-between pb-5 pt-5>
		<v-flex xs8>
			<label class="new-survey-label">Nombre de la Encuesta</label>
			<input 
				class="new-survey-input" 
				placeholder="Nombre de la Encuesta"
				v-model="newSurveyName"
				@keyup.enter="$emit('call-to-action', newSurveyName)"
			/>
		</v-flex>
		<v-flex xs2 pt-4>
			<v-btn 
				:disabled="btnDisabled"
				class="btn btn-action" 
				@click="$emit('call-to-action', newSurveyName)"
				color="primary"
			>
				{{ btnText }}
			</v-btn>
		</v-flex>
	</v-layout>
</template>

<script>
	function surveyName(value) {
		this.newSurveyName = value;
	}

	function data() {
		return {
			newSurveyName: '',
		};
	}

	export default {
		name: 'surveys-form',
		data,
		props: {
			btnDisabled: {
				default: true,
				type: Boolean,
			},
			btnText: {
				default: 'Finalizar',
				type: String,
			},
			surveyName: String,
		},
		watch: {
			surveyName,
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/surveys/surveys-form.vue